import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40d4d89b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "g-card"
}
const _hoisted_4 = { class: "list" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "footer" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "unit-price" }
const _hoisted_9 = { class: "quantity" }
const _hoisted_10 = { class: "ctrl" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "footer-view" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, " 注：单包裹重量低于300g最低申报金额为15RMB，高于300g最低申报金额为30RMB ", -1))
const _hoisted_16 = { class: "footer-ctrl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.productsList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list-item",
                  key: item.name_cn
                }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.name_cn), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, "单价 " + _toDisplayString(item.price), 1),
                      _createElementVNode("div", _hoisted_9, "数量 x " + _toDisplayString(item.quantity), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        class: "edit",
                        onClick: ($event: any) => (_ctx.editProduct(index))
                      }, [
                        _createVNode(_component_Icon, { icon: "btn_editing" }),
                        _createTextVNode(" 编辑 ")
                      ], 8, _hoisted_11),
                      _createElementVNode("div", {
                        class: "edit",
                        onClick: ($event: any) => (_ctx.removeProduct(index))
                      }, [
                        _createVNode(_component_Icon, { icon: "btn_trash" }),
                        _createTextVNode(" 删除 ")
                      ], 8, _hoisted_12)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13))
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", {
          class: "g-button add-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navProductEdit && _ctx.navProductEdit(...args)))
        }, "添加物品信息"),
        _createElementVNode("div", {
          class: "g-button next-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.backToOrder && _ctx.backToOrder(...args)))
        }, "下一步")
      ])
    ])
  ]))
}